import axios from "axios"

/**
 * Resolve the API origin for axios.
 * - Development: empty base URL so CRA's proxy (`package.json` → localhost:4001) is used
 * - Production: https://api.stargaterentals.com unless REACT_APP_API_URL overrides it
 */
export const getApiBaseUrl = () => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL.replace(/\/$/, "")
    }
    if (process.env.NODE_ENV === "production") {
        return "https://api.stargaterentals.com"
    }
    return ""
}

/** Turn relative /api/... (and /uploads/...) asset paths into absolute URLs when the SPA and API are on different hosts. */
export const resolveApiAssetUrl = (url) => {
    if (!url || typeof url !== "string") return url
    if (/^(https?:|data:|blob:)/i.test(url)) return url
    if (!url.startsWith("/")) return url
    const base = getApiBaseUrl()
    return base ? `${base}${url}` : url
}

export const createApiClient = ({ baseURL = getApiBaseUrl() } = {}) =>
    axios.create({
        baseURL,
        // Do not set a global Content-Type. JSON requests set it in requestJson;
        // FormData uploads must let the browser set multipart/form-data + boundary.
    })
